export default {
  billingType: {
    type: 'string',
    required: true,
  },
  startDate: {
    type: 'date',
    required: true,
  },
  endDate: {
    type: 'date',
    required: true,
  },
  periodPolicy: {
    type: 'string',
    required: true,
  },
  invoiceDateBusinessRule: {
    type: 'string',
    required: true,
  },
  scheduleItems: {
    type: 'array',
    maxSize: 100,
    required: true,
    forEach: {
      type: 'object',
      properties: {
        itemType: {
          type: 'string',
          required: false,
        },
        periodMonth: {
          type: 'string',
          required: {
            value: true,
            when: {
              '$.itemType': {
                ne: 'CHANGE_REQUEST',
              },
            },
          },
          maxSize: 255,
        },
        amount: {
          type: 'string',
          required: true,
        },
      },
    },
  },
};
